export default __webpack_public_path__ + "static/media/animus_employee_Efebe.e6688c89.png";